import { render, staticRenderFns } from "./EventParticipantsGrid.vue?vue&type=template&id=c22e171c"
import script from "./EventParticipantsGrid.vue?vue&type=script&lang=ts"
export * from "./EventParticipantsGrid.vue?vue&type=script&lang=ts"
import style0 from "./EventParticipantsGrid.vue?vue&type=style&index=0&id=c22e171c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports